import React, { useId } from 'react'
import PropTypes from 'prop-types'

export const FieldLabel = ({ htmlFor, children, hint }) => (
  <label className='se-field-label' htmlFor={htmlFor}>
    <span>{children}</span>
    {hint ? <span className='se-field-hint'>{hint}</span> : null}
  </label>
)

FieldLabel.propTypes = {
  htmlFor: PropTypes.string,
  children: PropTypes.node,
  hint: PropTypes.node,
}

export const useFieldIds = prefix => {
  const id = useId()
  return `${prefix}-${id}`
}
